export default __webpack_public_path__ + "static/media/login-banner.7b07a69d.jpg";